import { jsxs as l, Fragment as p, jsx as a } from "react/jsx-runtime";
import { message as d } from "antd";
import { I as m, _ as v } from "./AntdIcon-DyhIFdCf.js";
import * as c from "react";
var u = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" }, f = function(e, o) {
  return /* @__PURE__ */ c.createElement(m, v({}, e, {
    ref: o,
    icon: u
  }));
}, s = /* @__PURE__ */ c.forwardRef(f);
process.env.NODE_ENV !== "production" && (s.displayName = "CopyOutlined");
const O = ({
  text: t,
  children: e = /* @__PURE__ */ a(s, { className: "at-text-blue-500 hover:at-text-blue-500/70" }),
  messageConfig: o
}) => {
  const [r, i] = d.useMessage(o);
  return /* @__PURE__ */ l(p, { children: [
    i,
    /* @__PURE__ */ a("div", { onClick: ((n) => () => {
      navigator.clipboard ? navigator.clipboard.writeText(n).then(() => {
        r.success("複製成功");
      }).catch((x) => {
        r.error("OOPS! 複製失敗");
      }) : r.error("OOPS! 剪貼簿不可用");
    })(t), className: "at-cursor-pointer", children: e })
  ] });
};
export {
  O as C,
  s as R
};
